import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useDeleteCaseTask = (): UseMutationResult<void, Error, { caseTaskId: string }> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ caseTaskId }) => {
            const response = await fetch(apiUrl(`/case-task/delete/${caseTaskId}`), {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
            });
            await handleJsonApiError(response);
        },
        onSuccess: async (_data) => {
            await queryClient.invalidateQueries({
                queryKey: ["case-tasks"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["dashboard-tasks-table-data"],
            });
        },
    });
};
